import { render } from "./TemplateDetailsComponent.vue?vue&type=template&id=b344ee74"
import script from "./TemplateDetailsComponent.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__